import { useState, useCallback } from 'preact/hooks';
import { SearchResponse, SearchResult } from './types';
import { SearchResults } from './components/search-results/search-results';
import { SearchForm } from './components/search-form/search-form';

import './app.css';

export function App() {
  const [results, setResults] = useState<SearchResult[]>([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = useCallback(async (query: string) => {
    setLoading(true);
    try {
      const response = await fetch(
        `/api/v1/search?q=${encodeURIComponent(query)}`,
      );
      const data: SearchResponse = await response.json();
      setResults(data.results);
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <div class="search-app">
      <SearchForm onSearch={handleSearch} loading={loading} />
      <SearchResults results={results} onClose={() => setResults([])} />
    </div>
  );
}
